import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import ModalController from 'webmodals/modal.controller'
import modals from 'webmodals/modals'

class AddMediaPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus()
        $ctrl.title = options.title || `Add Media...`;
        $ctrl.subTitle = options.subTitle;

        $ctrl.request = Object.assign({}, options.media);

        console.debug('AddMediaPromptController', options);
    }

    upload($files) {
        let $ctrl = this;
        if(($files && $files.length) || ($ctrl.request.urls && $ctrl.request.urls.length)) {
            $ctrl.$files = $files;
            $ctrl.uploading = {};
            let req = {
                request: $ctrl.request,
                files: $files
            };

            $ctrl.bus.upload('CreateMedia.json', req).then(
                res => {
                    $ctrl.request.urls = [];
                    $ctrl.close(res.data);
                }, res => modals.alert(JSON.stringify(res),'Could not save media!'));
        }
    }

    submit() {
        const $ctrl = this;
    }
}

export default AddMediaPromptController;